// appConstants.js
window.appConstants = {
  AppName: "Namapages",
  Version: "1.0.0",
  Allow: "NAM",
  clicklogUrl: "https://analytics.codeandtech.com/clicklogger",
  enableClickLogs: true
};